/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Usecases_Item_1_TitleInputs */

const es_home_usecases_item_1_title = /** @type {(inputs: Home_Usecases_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Búsqueda Inteligente de Documentos`)
};

const en_home_usecases_item_1_title = /** @type {(inputs: Home_Usecases_Item_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intelligent Document Search`)
};

/**
* | output |
* | --- |
* | "Intelligent Document Search" |
*
* @param {Home_Usecases_Item_1_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_usecases_item_1_title = /** @type {((inputs?: Home_Usecases_Item_1_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Usecases_Item_1_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_usecases_item_1_title(inputs)
	return en_home_usecases_item_1_title(inputs)
});
export { home_usecases_item_1_title as "home.usecases.item_1_title" }